/*
 * @Author: your name
 * @Date: 2021-12-14 10:19:00
 * @LastEditTime: 2022-02-16 09:44:31
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \lzxy-homepage\src\commons\productManager.ts
 */

import { ProductDetail } from './productTreeModel'
import { ProductService } from './productService'

export class ProductManager {
  cusType = 'user'
  page = 1
  size = 10
  topProduct = []
  productAll = []
  productTreeData: ProductDetail = new ProductDetail('', '', '', '', '')
  service: ProductService
  constructor (service: ProductService) {
    this.service = service
  }

  async getProductTree () {
    const cusType = this.cusType
    const res = await this.service.getProductTree(cusType)
    console.log(res)
    this.productTreeData = res
  }
}
